import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';
import { getRouteByActivityType } from 'src/app/board/activity/activity-shared/activity-shared-routes';
import { RouteActivityType } from 'src/app/board/activity/activity.constants';

export const activityMediaLibrariesRoutes: MenuInterface[] = [
    {
        code: 'MediaLibraryParameters',
        route: getRouteByActivityType('ActivityParameters', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryPermanenceParameters',
        route: getRouteByActivityType('PermanencesSettings', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryMediaFamily',
        route: getRouteByActivityType('MediaFamily', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryMediaCatalog',
        route: getRouteByActivityType('MediaCatalog', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryStatusParameters',
        route: getRouteByActivityType('StatusParameters', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryStockQuantities',
        route: getRouteByActivityType('StockQuantities', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryMovements',
        route: getRouteByActivityType('StockMovements', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryReservationsList',
        route: getRouteByActivityType('BookingsList', RouteActivityType.MediaLibraries)
    },
    {
        code: 'MediaLibraryPrintLabelParameters',
        route: [
            {
                content: 'activity/media-libraries/settings/sheets-models/list',
                focus: 'empty'
            }, {
                primaryRoute: 'content',
                queryParams: {closeButton: '1'}
            }
        ]
    },
    {
        code: 'MediaLibraryBlockage',
        route: [
            {
                content: 'activity/media-libraries/stocks/blockages/list',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'MediaLibraryPrintLabel',
        route: [
            {
                content: 'activity/media-libraries/prints/action-label-sheets',
                focus: 'empty',
            }, 'content'
        ]
    },
    {
        code: 'MediaLibraryBorrowReserve',
        route: [
            {
                content: ['activity', 'media-libraries', 'loan'],
                focus: 'empty'
            }, 'content'
        ]
    },
    {
        code: 'MediaLibraryImportCatalog',
        route: getRouteByActivityType('MediaCatalogImport', RouteActivityType.MediaLibraries)
    },
];
